const STATE: {
  [key: string]: {
    id: number;
    name: string;
    agency: string;
    businessSearchPage: string;
  };
} = {
  AK: {
    id: 1,
    name: 'Alaska',
    agency: 'Division of Corporations, Business and Professional Licensing',
    businessSearchPage:
      'https://www.commerce.alaska.gov/cbp/main/search/entities',
  },
  WA: {
    id: 2,
    name: 'Washington',
    agency: 'Secretary of State',
    businessSearchPage: 'https://ccfs.sos.wa.gov/#/',
  },
  OR: {
    id: 3,
    name: 'Oregon',
    agency: 'Secretary of State',
    businessSearchPage:
      'https://egov.sos.state.or.us/br/pkg_web_name_srch_inq.login',
  },
  NV: {
    id: 4,
    name: 'Nevada',
    agency: 'Secretary of State',
    businessSearchPage: 'https://esos.nv.gov/EntitySearch/OnlineEntitySearch',
  },
  CA: {
    id: 5,
    name: 'California',
    agency: 'Secretary of State',
    businessSearchPage: 'https://bizfileonline.sos.ca.gov/search',
  },
  HI: {
    id: 6,
    name: 'Hawaii',
    agency: 'Department of Commerce and Consumer Affairs',
    businessSearchPage: 'https://hbe.ehawaii.gov/documents/search.html',
  },
  ID: {
    id: 7,
    name: 'Idaho',
    agency: 'Secretary of State',
    businessSearchPage: 'https://sosbiz.idaho.gov/search/business',
  },
  MT: {
    id: 8,
    name: 'Montana',
    agency: 'Secretary of State',
    businessSearchPage: 'https://biz.sosmt.gov/search/business',
  },
  WY: {
    id: 9,
    name: 'Wyoming',
    agency: 'Secretary of State',
    businessSearchPage: 'https://wyobiz.wyo.gov/business/filingsearch.aspx',
  },
  UT: {
    id: 10,
    name: 'Utah',
    agency: 'Department of Commerce',
    businessSearchPage:
      'https://businessregistration.utah.gov/EntitySearch/OnlineEntitySearch',
  },
  CO: {
    id: 11,
    name: 'Colorado',
    agency: 'Secretary of State',
    businessSearchPage:
      'https://www.sos.state.co.us/ucc/pages/biz/bizSearch.xhtml',
  },
  AZ: {
    id: 12,
    name: 'Arizona',
    agency: 'Arizona Corporation Commission',
    businessSearchPage: 'https://apps.azsos.gov/apps/tntp/se.html',
  },
  NM: {
    id: 13,
    name: 'New Mexico',
    agency: 'Secretary of State',
    businessSearchPage: 'https://enterprise.sos.nm.gov/search/business',
  },
  ND: {
    id: 14,
    name: 'North Dakota',
    agency: 'Secretary of State',
    businessSearchPage: 'https://firststop.sos.nd.gov/search/business',
  },
  SD: {
    id: 15,
    name: 'South Dakota',
    agency: 'Secretary of State',
    businessSearchPage:
      'https://sosenterprise.sd.gov/BusinessServices/Business/FilingSearch.aspx',
  },
  MN: {
    id: 16,
    name: 'Minnesota',
    agency: 'Secretary of State',
    businessSearchPage: 'https://mblsportal.sos.mn.gov/Business/Search',
  },
  IN: {
    id: 17,
    name: 'Indiana',
    agency: 'Secretary of State',
    businessSearchPage: 'https://bsd.sos.in.gov/publicbusinesssearch',
  },
  NE: {
    id: 18,
    name: 'Nebraska',
    agency: 'Secretary of State',
    businessSearchPage:
      'https://www.nebraska.gov/sos/corp/corpsearch.cgi?nav=search',
  },
  KS: {
    id: 19,
    name: 'Kansas',
    agency: 'Secretary of State',
    businessSearchPage:
      'https://www.sos.ks.gov/eforms/BusinessEntity/Search.aspx',
  },
  OK: {
    id: 20,
    name: 'Oklahoma',
    agency: 'Secretary of State',
    businessSearchPage: 'https://www.sos.ok.gov/corp/corpInquiryFind.aspx',
  },
  TX: {
    id: 21,
    name: 'Texas',
    agency: 'Secretary of State',
    businessSearchPage: 'https://www.sos.state.tx.us/corp/sosda/index.shtml',
  },
  AR: {
    id: 22,
    name: 'Arkansas',
    agency: 'Secretary of State',
    businessSearchPage: 'https://www.ark.org/corp-search/',
  },
  LA: {
    id: 23,
    name: 'Louisiana',
    agency: 'Secretary of State',
    businessSearchPage:
      'https://coraweb.sos.la.gov/CommercialSearch/CommercialSearch.aspx',
  },
  MO: {
    id: 24,
    name: 'Missouri',
    agency: 'Secretary of State',
    businessSearchPage:
      'https://bsd.sos.mo.gov/BusinessEntity/BESearch.aspx?SearchType=0',
  },
  WI: {
    id: 25,
    name: 'Wisconsin',
    agency: 'Department of Financial Institutions',
    businessSearchPage: 'https://apps.dfi.wi.gov/apps/corpsearch/search.aspx',
  },
  IL: {
    id: 26,
    name: 'Illinois',
    agency: 'Secretary of State',
    businessSearchPage: 'https://apps.ilsos.gov/businessentitysearch/',
  },
  CT: {
    id: 27,
    name: 'Connecticut',
    agency: 'Secretary of State',
    businessSearchPage:
      'https://service.ct.gov/business/s/onlinebusinesssearch?language=en_US',
  },
  DE: {
    id: 28,
    name: 'Delaware',
    agency: 'Division of Corporations',
    businessSearchPage:
      'https://icis.corp.delaware.gov/ecorp/entitysearch/namesearch.aspx',
  },
  DC: {
    id: 29,
    name: 'Dist. of Columbia',
    agency: 'Department of Licensing & Consumer Protection',
    businessSearchPage:
      'https://corponline.dlcp.dc.gov/homepage/business-search',
  },
  FL: {
    id: 30,
    name: 'Florida',
    agency: 'Department of State',
    businessSearchPage: 'https://dos.fl.gov/sunbiz/search/',
  },
  GA: {
    id: 31,
    name: 'Georgia',
    agency: 'Secretary of State',
    businessSearchPage: 'https://ecorp.sos.ga.gov/businesssearch',
  },
  KY: {
    id: 32,
    name: 'Kentucky',
    agency: 'Secretary of State',
    businessSearchPage:
      'https://sosbes.sos.ky.gov/BusSearchNProfile/search.aspx',
  },
  IA: {
    id: 33,
    name: 'Iowa',
    agency: 'Secretary of State',
    businessSearchPage: 'https://sos.iowa.gov/search/business/search.aspx',
  },
  ME: {
    id: 34,
    name: 'Maine',
    agency: 'Secretary of State',
    businessSearchPage:
      'https://apps3.web.maine.gov/nei-sos-icrs/ICRS?MainPage=x',
  },
  MD: {
    id: 35,
    name: 'Maryland',
    agency: 'Department of Assessments and Taxation',
    businessSearchPage:
      'https://egov.maryland.gov/businessexpress/entitysearch',
  },
  MA: {
    id: 36,
    name: 'Massachusetts',
    agency: 'Secretary of the Commonwealth',
    businessSearchPage:
      'https://corp.sec.state.ma.us/corpweb/CorpSearch/CorpSearch.aspx',
  },
  MI: {
    id: 37,
    name: 'Michigan',
    agency: 'Department of Licensing & Regulatory Affairs',
    businessSearchPage:
      'https://mibusinessregistry.lara.state.mi.us/search/business',
  },
  MS: {
    id: 38,
    name: 'Mississippi',
    agency: 'Secretary of State',
    businessSearchPage:
      'https://corp.sos.ms.gov/corp/portal/c/page/corpBusinessIdSearch/portal.aspx',
  },
  NH: {
    id: 39,
    name: 'New Hampshire',
    agency: 'Secretary of State',
    businessSearchPage: 'https://quickstart.sos.nh.gov/online/BusinessInquire',
  },
  NJ: {
    id: 40,
    name: 'New Jersey',
    agency: 'Department of the Treasury',
    businessSearchPage: 'https://www.njportal.com/dor/businessnamesearch/',
  },
  NY: {
    id: 41,
    name: 'New York',
    agency: 'Department of State',
    businessSearchPage: 'https://apps.dos.ny.gov/publicInquiry/',
  },
  NC: {
    id: 42,
    name: 'North Carolina',
    agency: 'Secretary of State',
    businessSearchPage:
      'https://sosnc.gov/online_services/search/by_title/search_Business_Registration',
  },
  OH: {
    id: 43,
    name: 'Ohio',
    agency: 'Secretary of State',
    businessSearchPage: 'https://businesssearch.ohiosos.gov/',
  },
  PA: {
    id: 44,
    name: 'Pennsylvania',
    agency: 'Department of State',
    businessSearchPage: 'https://file.dos.pa.gov/search/business',
  },
  RI: {
    id: 45,
    name: 'Rhode Island',
    agency: 'Secretary of State',
    businessSearchPage:
      'https://business.sos.ri.gov/CorpWeb/CorpSearch/CorpSearch.aspx',
  },
  SC: {
    id: 46,
    name: 'South Carolina',
    agency: 'Secretary of State',
    businessSearchPage:
      'https://businessfilings.sc.gov/businessfiling/Entity/Search',
  },
  TN: {
    id: 47,
    name: 'Tennessee',
    agency: 'Secretary of State',
    businessSearchPage: 'https://tncab.tnsos.gov/business-entity-search',
  },
  VT: {
    id: 48,
    name: 'Vermont',
    agency: 'Secretary of State',
    businessSearchPage:
      'https://bizfilings.vermont.gov/business/businesssearch',
  },
  VA: {
    id: 49,
    name: 'Virginia',
    agency: 'State Corporation Commission',
    businessSearchPage: 'https://cis.scc.virginia.gov/EntitySearch/Index',
  },
  WV: {
    id: 50,
    name: 'West Virginia',
    agency: 'Secretary of State',
    businessSearchPage: 'https://apps.wv.gov/sos/businessentitysearch/',
  },
  AL: {
    id: 51,
    name: 'Alabama',
    agency: 'Secretary of State',
    businessSearchPage:
      'https://www.sos.alabama.gov/government-records/business-entity-records',
  },
};

export const states = Object.fromEntries(
  Object.entries(STATE)
    .sort(
      ([abbreviationA, { name: nameA }], [abbreviationB, { name: nameB }]) =>
        nameA.localeCompare(nameB),
    )
    .map(([abbreviation, { id, name }]) => [
      abbreviation,
      { id: id.toString(), name },
    ]),
);

export const enum StateNameEnum {
  Alabama = 'Alabama',
  Alaska = 'Alaska',
  Arizona = 'Arizona',
  Arkansas = 'Arkansas',
  California = 'California',
  Colorado = 'Colorado',
  Connecticut = 'Connecticut',
  Delaware = 'Delaware',
  Florida = 'Florida',
  Georgia = 'Georgia',
  Hawaii = 'Hawaii',
  Idaho = 'Idaho',
  Illinois = 'Illinois',
  Indiana = 'Indiana',
  Iowa = 'Iowa',
  Kansas = 'Kansas',
  Kentucky = 'Kentucky',
  Louisiana = 'Louisiana',
  Maine = 'Maine',
  Maryland = 'Maryland',
  Massachusetts = 'Massachusetts',
  Michigan = 'Michigan',
  Minnesota = 'Minnesota',
  Mississippi = 'Mississippi',
  Missouri = 'Missouri',
  Montana = 'Montana',
  Nebraska = 'Nebraska',
  Nevada = 'Nevada',
  'New Hampshire' = 'New Hampshire',
  'New Jersey' = 'New Jersey',
  'New Mexico' = 'New Mexico',
  'New York' = 'New York',
  'North Carolina' = 'North Carolina',
  'North Dakota' = 'North Dakota',
  Ohio = 'Ohio',
  Oklahoma = 'Oklahoma',
  Oregon = 'Oregon',
  Pennsylvania = 'Pennsylvania',
  'Rhode Island' = 'Rhode Island',
  'South Carolina' = 'South Carolina',
  'South Dakota' = 'South Dakota',
  Tennessee = 'Tennessee',
  Texas = 'Texas',
  Utah = 'Utah',
  Vermont = 'Vermont',
  Virginia = 'Virginia',
  Washington = 'Washington',
  'West Virginia' = 'West Virginia',
  Wisconsin = 'Wisconsin',
  Wyoming = 'Wyoming',
}

export type StateCode = keyof typeof STATE;

export default STATE;
